import { render, staticRenderFns } from "./CashierAccount.vue?vue&type=template&id=b2a03b80&scoped=true"
import script from "./CashierAccount.vue?vue&type=script&lang=js"
export * from "./CashierAccount.vue?vue&type=script&lang=js"
import style0 from "./CashierAccount.vue?vue&type=style&index=0&id=b2a03b80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2a03b80",
  null
  
)

export default component.exports